import { useQuery } from '@tanstack/react-query';
import { listDrivers } from '../../../api/drivers';
import { queryKeys } from '../../../api/queryKeys';

export interface DriverOption {
  enc_id: string;
  driver_name: string;
}

/**
 * Fetches all active drivers for the replay selector.
 * Uses enc_id (from the server's DriverSummary) so it is compatible
 * with the history endpoint and ReplayControls.
 * Cached for 5 minutes — driver list changes rarely during a shift.
 */
export function useActiveDrivers() {
  return useQuery({
    queryKey: queryKeys.driversAdmin.activeForMap(),
    queryFn: async (): Promise<DriverOption[]> => {
      const res = await listDrivers({ page: 1, limit: 200, status: 'active' });
      return res.drivers.map((d) => ({
        enc_id: d.enc_id,
        driver_name: d.name,
      }));
    },
    staleTime: 5 * 60_000,
  });
}
